// extracted by mini-css-extract-plugin
export default {"minimal_header":"MinimalHeader_minimal_header__Fv3nD"};